// extracted by mini-css-extract-plugin
export var productReviewBlock = "ArticleProductReviewBlock-module--productReviewBlock--2P9Sl";
export var topBlock = "ArticleProductReviewBlock-module--topBlock--MLobr";
export var prosAndCons = "ArticleProductReviewBlock-module--prosAndCons--1C736";
export var imageButtonColumn = "ArticleProductReviewBlock-module--imageButtonColumn--3JPcW";
export var articleStarRating = "ArticleProductReviewBlock-module--articleStarRating--3MZC4";
export var buttonGroup = "ArticleProductReviewBlock-module--buttonGroup--j95E4";